<template>
  <div class="app-page">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      :height="loadingHeight"
      fixed
      top
      class="app-page-loading"
    />

    <v-row no-gutters>
      <v-col cols="12">
        <div class="app-page-header">
          <div class="app-page-header__left">
            <div class="title font-weight-regular grey--text mb-1">
              <span class="font-weight-bold">
                {{ title }}
              </span>
            </div>

            <div class="body-2 grey--text text--lighten-2">
              {{ subtitle }}
            </div>
          </div>

          <div v-if="$slots.actions" class="app-page-header__right">
            <slot name="actions" />
          </div>
        </div>
      </v-col>

      <v-col cols="12" class="mt-7">
        <slot name="content" />
      </v-col>

      <slot name="dialogs" />
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AppPage',

  props: {
    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    loadingHeight: {
      type: [Number, String],
      default: 6,
    },
  },
}
</script>

<style scoped>
.app-page {
  position: relative;
  min-height: 300px;
}

.app-page-loading {
  z-index: 9999 !important;
}

.app-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.app-page-header__left {
  flex: 1;
  min-width: 0;
}

.app-page-header__right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

@media (max-width: 960px) {
  .app-page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .app-page-header__right {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
